module.exports = __webpack_public_path__ + "static/media/icon-investment-soon.0dea4e20.svg";